import { Component, OnInit, ViewChild, ViewContainerRef, Injectable, AfterViewInit } from '@angular/core';
import { ItemService } from '../../services/item/item.service';
import { AnswerService } from '../../services/answer/answer.service';
import { RestService } from '../../services/rest/rest.service';
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { Item } from '../../model/item';
import { ReviewTest } from '../../model/reviewTest';
import { Answer } from '../../model/answer';
import { Token } from "../../model/token";
import { TokenService } from "../../services/state/token.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { Router } from '@angular/router';
import { StateService } from "../../services/state/state.service";
import { State } from "../../model/state";
import { WelcomeService } from "../../services/welcome/welcome.service";
import { WelcomeDTO } from "../../model/welcome.info";
import { DeleteService } from "../../services/data/delete.service";
import { LoginService } from '../../services/login/login.service';
import { TranslateService } from '@ngx-translate/core';
import { FooterVisualizerComponent } from '../footer-visualizer/footer-visualizer.component';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { AddComponentService } from "../../services/addComponent/add-component.service";
import { ItemControlService } from '../../services/item/item-control.service';
import { AdaptativeService } from '../../services/adaptativeService/adaptative-service';
import { Session } from '../../model/session';
import { AdaptativePuntajeDTO } from '../../model/adaptive.puntaje.dto';
import { PuntajePruebasDTO } from '../../model/adaptive.puntaje.pruebas.dto';
import { examenPruebas } from '../../constants/examenPruebas';
import { examen } from '../../constants/examenPruebas';
import { CodResp } from '../../constants/codigosMensajes';
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { DateServerService } from '../../services/dateServerService/date-server.service';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import * as fs from 'file-saver';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


//Variable del global scope para funcionamiento de MathJax
declare var MathJax: any;

//Variable del global scope para utilizar jquery
declare var $: any;

declare var ClassicEditor: any;

@Injectable()
export class Globals {
  testChrono: any;
}

@Component({
  selector: 'app-visualizer-adaptative',
  templateUrl: './visualizer.component.html',
  styleUrls: ['./visualizer.component.css'],
  providers: [ItemService,
    AnswerService,
    RestService,
    TokenService,
    DeleteService,
    LoginService,
    AddComponentService,
    FooterVisualizerComponent
  ]
})
/*Controlador de la pagina visualizer.html se encarga de la visualizacion
de los items*/
export class VisualizerAdaptativeComponent implements OnInit, AfterViewInit {

  //Inyeccion del componente interno que compilara el html de los items
  @ViewChild('container', { read: ViewContainerRef, static: false })
  container: ViewContainerRef;

  private viewInitialized = false;

  //Item que se muestra en el contenedor
  public actual: Item;

  //Flag que indica si hay conexion a internet o no
  //public online: boolean;

  //Variable para control de respuesta
  public respuesta: any;

  //El token del usuario que presenta el examen
  private token: Token;

  //La sesion de la prueba que se esta desarrollando actualmente
  public sesion: number;

  //Indica si todos las respuestan han sido sincronizadas
  public allSynced: boolean;

  //Numero de item que muestra inicalmente el visualizador
  public initItem: number;

  //Indica si se debe mostrar el boton de finalizar
  public mostrarFinalizar: boolean;

  //Almacena toda la informacion de la pagina de bienvenida
  public welcomeData: WelcomeDTO;

  //Flag de control para mostrar o no el boton de scroll
  //public showScrollBtn: boolean;

  //Ayuda a controlar la posicion del scroll
  public position: number;

  //Captura la respuesta del editor en Respuesta abierta
  public editorContent: string;

  public rtaArea: string;

  //Variable auxiliar para saber si una respuesta es marcada o no
  private previousMark: any;

  //Variable auxiliar para conocer la cantidad de ítems que tiene una sesión
  public totalItemsSesion: Item[];

  //Arreglo que combia datos de ítems con sus respectivas respuestas, para la contrucción de la revisión
  public totalReviewTest: ReviewTest[];

  //Flag de control para mostrar o no la revisión de prueba
  public showReview: Boolean;

  //Captura el objeto para crear el archivo de respuestas
  public textoBlob: any;

  //Captura el string de respuestas
  public stringResp: any;

  //Captura el pasword del delegado
  public passwordDelegado: string;

  //Captura la respuesta del editor en Respuesta abierta
  public validationPassword: Boolean;

  //Captura la respuesta del editor en Respuesta abierta
  public validationAnswerSincroniced: Boolean;

  //Muestra el reintento para sincronizar respuestas
  public downloadinProcess: Boolean;

  //captuta el nombre del archivo
  public nameFile: string;

  //Permite mostrar el loading para tiempos largos de espera-
  public loading: boolean;

  //Flag de control para mostrar o no el resumen de respuestas
  public showSummary: Boolean;

  //Tabla auxiliar, que define los límites (desde-hasta) para mostrar las respuestas en el resumen
  public dataTables: any[];

  //Flag de control que permite finalizar el test, si el evaluado está de acuerdo con el resumen de respuestas
  public checkAgree: any;

  //Flag que se encarga de manejar la renderización botón atras.
  public renderBtn: any;

  //Atributo que indica el puntaje que tiene el evaluado
  public score: string;

  //Atributo que contiene la sumatoria de todos los puntajes de las pruebas.
  public puntajeTotal: AdaptativePuntajeDTO;

  //Atributo que contiene la sumatoria de todos los puntajes de las pruebas.
  public puntajeTotalExamen: PuntajePruebasDTO;

  //Mensaje salida error modal.
  public mensaje: string;
  /**
   * Atributo que contiene la información de la sesión.
  */
  public sessionInfo: Session;

  /**Flag que deshabilita el boton de continuar para  evitar doble clic */
  public deshabilitarContinuar: Boolean;

  /**Identifica si es ultima sesion */
  public esUltima: boolean = false;

  /**Atributo utilizado para visualizar archivo pdf */
  // public urlPdfSafe: any;

  // En las propiedades del componente
  public urlPdfSafe: SafeResourceUrl | null = null;
  public urlSafeChat: SafeResourceUrl | null = null;

  //Constructor de la clase
  constructor(private _router: Router,
    private _itemService: ItemService,
    private _answerService: AnswerService,
    private _restService: RestService,
    public _answerController: AnswerControlService,
    private _tokenController: TokenControlService,
    private _stateService: StateService,
    private _welcomeDataService: WelcomeService,
    private _loginService: LoginService,
    private _deleteService: DeleteService,
    private _translateService: TranslateService,
    public _itemControlService: ItemControlService,
    public _adaptiveService: AdaptativeService,
    private _configurationControlService: ConfigurationControlService,
    public _addComponent: AddComponentService,
    public _dateServerService: DateServerService,
    private sanitizer: DomSanitizer) {
    this.actual = new Item(0, '', 0, 0, 0, 0, '', '', 0, 0, 0, null, null, null, 0, null);
    this._answerController.started = true;
    this._answerController.progress = 0;
    this._answerController.marcarRespuesta = 0;
    this._answerController.previousAnswer = null;
    this.mostrarFinalizar = false;
    this.welcomeData = this._welcomeDataService.data;
    //this.showScrollBtn = false;
    this.position = 50;
    this.score = '0';
    this.mensaje = "";
    let self = this;
    this.getPublicIp();
    self.token = _tokenController.token;

    if (this._stateService.state == null || this._stateService.state == undefined) {
      this._itemService.saveState(new State(1, 1, 1, self.token.credentialId));
      self.sesion = 1;
      self.initItem = 1;
    } else {
      self.sesion = self._stateService.state.sesion;
      self.initItem = self._stateService.state.item;
    }

    this.sessionInfo = new Session("", "", new Date(), null, null);
    this.puntajeTotal = new AdaptativePuntajeDTO('', '', [], '');

    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang(_configurationControlService.examConfiguration.language);
    this._translateService.use(_configurationControlService.examConfiguration.language);

    this.validationPassword = false;
    this.validationAnswerSincroniced = false;
    this.downloadinProcess = false;
    this.loading = false;
    this.deshabilitarContinuar = false;
  }

  /*Metodo encargado de consultar la ip del cliente para almacenarla
  en el objeto respuesta*/
  public getPublicIp() {
    let self = this;
    this._loginService.getIp().then(res => {
      self._configurationControlService.publicIp = res['ip'];
      self._answerController.publicIp = res['ip'];
    })
  }

  /*Necesario debido a la implementacion de la interfaz OnInit
  se ejecuta*/
  ngOnInit() {
    let self = this;
    this.deshabilitarContinuar = false;
    /*self.online = navigator.onLine;
    window.addEventListener('offline', function (e) {
      self.online = false;
    });
    window.addEventListener('online', function (e) {
      self.online = true;
    });*/

    this._configurationControlService.sessionInfo.sesion = this._stateService.state.sesion;
    self._loginService.saveSessionInfo(self._tokenController.getTokenValue(), self._tokenController.token.tokenId, ESTADO_SESSION_INFO.INICIAR_SIMULACION).then((res: any) => {
      let result = res == CodResp[0].codigo ? 'S' : 'N';
      if (result == 'S') {
        console.log("Actualizó información sesión");
      }
    });

    this.loadWaterMark();

    // Sanitización URL del Chat
    // if (this._configurationControlService.chatUrl) {
    //   this.urlSafeChat = this.sanitizer.bypassSecurityTrustResourceUrl(
    //     this._configurationControlService.chatUrl
    //   );
    // }
    // Inicializar URL del chat como vacío o con una URL por defecto
    this.urlSafeChat = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');

  }

  ngAfterViewInit() {
    // Esperar a que la vista esté completamente inicializada
    this.viewInitialized = true;

    setTimeout(() => {
      if (this._itemControlService.item) {
        console.log('Cargando item desde AfterViewInit:', this._itemControlService.item);
        this.loadItemAdaptive();
      } else {
        console.error('Error: No se puede cargar el item porque _itemControlService.item es null');
        this.handleItemLoadError();
      }
    }, 100);

    // ✅ Verificamos que haya un item válido antes de cargar
    if (this._itemControlService.item) {
      this.loadItemAdaptive();
    } else {
      console.error('Error: No se puede cargar el item porque _itemControlService.item es null o undefined');
      // ✅ Alternativa: Intentar cargar directamente desde el estado guardado
      // Comprobamos tanto una posible propiedad legacy 'itemCode' como la propiedad 'item' existente en State.
      if (this._stateService.state && ((this._stateService.state as any).itemCode || this._stateService.state.item)) {
        // Determinamos el código del item: preferimos itemCode si existe, si no usamos item convertido a string.
        const itemCode = (this._stateService.state as any).itemCode ? (this._stateService.state as any).itemCode : this._stateService.state.item.toString();
        console.log(`Intentando recuperar item desde el estado: ${itemCode}`);

        this._itemService.resolveItemByCode(
          itemCode,
          this._tokenController.token.token,
          this._tokenController.token.tokenId,
          this.sesion.toString()
        ).then((item: Item) => {
          if (item) {
            this._itemControlService.item = item;
            this._itemControlService.itemCode = itemCode;
            this.loadItemAdaptive();
          } else {
            this.handleItemLoadError();
          }
        }).catch(error => {
          console.error('Error al cargar item desde estado:', error);
          this.handleItemLoadError();
        });
      } else {
        console.error('No hay código de item en el estado guardado');
        this.handleItemLoadError();
      }
    }

    // Si tienes una URL para el chat, sanitízala
    // if (this._configurationControlService.chatUrl) {
    //   this.urlSafeChat = this.sanitizer.bypassSecurityTrustResourceUrl(
    //     this._configurationControlService.chatUrl
    //   );
    // }

  }

  /**
   * Maneja el error al intentar cargar un ítem: registra, muestra el modal de error y reactiva la interfaz.
   */
  private handleItemLoadError(): void {
    console.error('No se pudo cargar el ítem desde el estado ni desde el servidor.');
    this.mensaje = 'No se pudo cargar el ítem. Por favor contacte con el aplicador.';
    // Aseguramos que el botón continuar no quede bloqueado
    this.deshabilitarContinuar = false;
  }

  /** Metodo encargado de cargar la marca de agua */
  public loadWaterMark() {
    switch (this._configurationControlService.ambiente) {
      case "demo":
        $("#modalResume").css("background-image", "url(/src/app/resources/img/demo.png)");
        break
      case "preIcfes":
        $("#modalResume").css("background-image", "url(/src/app/resources/img/demoPreIcfes.png)");
        $("#modalResume").css("background-image", "url(/src/app/resources/img/demoPreResultados.png)");
        $("#modalResume").css("background-repeat", "repeat");
        break
      case "produccion":
        $("body").css("background-image", "url(" + this._welcomeDataService.waterMark + ")");
        $("body").css("background-repeat", "repeat");
        $("#modalResume").css("background-image", "url(" + this._welcomeDataService.waterMark + ")");
        $("#modalResume").css("background-repeat", "repeat");
        break;
    }
  }

  //Obtiene el valor del atributo respuesta
  public getRespAng(): any {
    return this.respuesta;
  }

  /*Se encarga de establecer el foco en la numeracion de los items
  cuando hay un cambio de item y reiniciar la posicion del scroll
  para que la visualizacion de la pagina este en la parte de arriba*/
  public focusOnItemNumeration() {
    $("#item_numeration").focus();
    window.scrollTo(0, 0);
  }


  /**
  * Método que se encarga de cargar item si es adaptativo.
  */
  public loadItemAdaptive() {
    // ✅ Verificamos que exista el item antes de continuar
    if (!this._itemControlService.item || !this.container) {
      console.warn('Vista no inicializada o container no disponible');
      return;
    }

    this.deshabilitarContinuar = true;

    if (!this._itemControlService.item) {
      console.error('Error: No hay item disponible para cargar');
      this.deshabilitarContinuar = false;
      return;
    }

    console.log('Cargando item:', this._itemControlService.item);

    this.actual = this._itemControlService.item;
    this._answerController.itemId = this.actual.itemId;
    this._answerController.itemOrder = this.actual.orderVisual;
    this._answerController.sesion = this.actual.sesion;
    this._answerController.itemType = this.actual.type;
    this.getPublicIp();

    // ✅ Verificamos que container esté disponible
    if (this.container) {
      console.log('Añadiendo componente al container');
      this._addComponent.addComponent(this.actual.content, this.container, '', this);
    } else {
      console.error('Container no está disponible');
    }

    this.deshabilitarContinuar = false;
  }


  //Se encarga del guardado de una respuesta

  public saveAnswer() {
    let self = this;
    this.respuesta = this._answerController.getRespuesta();
    let answer = new Answer(this.token.credentialId, this.actual.itemId, this._dateServerService.getDateServer(),
      this.respuesta, 'N', self.actual.sesion, self.actual.order,
      self._answerController.publicIp, self._answerController.open,
      self._answerController.marcarRespuesta);
    this._answerService.saveAnswer(answer);
  }

  //Metodo encargado de la navegacion hacia el item siguiente, valida entre prueba normal y adaptativa.
  public stepForward() {
    this.mostrarFinalizar = false;
    this.siguienteItemAdaptativo();
  }

  /**
  * Método que se encarga de obtener el siguiente item en una
  * prueba electrónica adaptativa.
  */
  public siguienteItemAdaptativo() {
    let self = this;
    self.deshabilitarContinuar = true;
    if (this.validarRespuestaVacias()) {
      return;
    }

    let answer = new Answer(this._tokenController.token.credentialId,
      this.actual.itemId, this._dateServerService.getDateServer(),
      this._answerController.respuesta, 'N',
      this._answerController.sesion,
      this._answerController.itemOrder,
      this._answerController.publicIp,
      this._answerController.open,
      this._answerController.marcarRespuesta);
    this._restService.postSynchronize(this._tokenController.token.token, answer, this._tokenController.token.tokenId).then(res => {
      this._answerController.respuesta = null;
      self._adaptiveService.nextItem(self._tokenController.token.token, self._itemControlService.itemCode, answer, self._tokenController.token.credentialId.toString(), this.actual.type, self._tokenController.token.tokenId).then(
        data => {
          if (data && data.codigo == "00") {

            if (data.puntaje) {
              self.score = data.puntaje + '';
              self.score = self.score.substring(0, (self.score.indexOf('.') + 3));
            } else if (data.puntaje == 0) {
              self.score = data.puntaje + '';
            }

            if (data.idItem) {
              self._itemService.resolveItemByCode(
                data.idItem,
                self._tokenController.token.token,
                this._tokenController.token.tokenId,
                this._answerController.sesion.toString()).then(
                  item => {
                    self._itemControlService.item = item;
                    self._itemControlService.item.orderVisual = data.numeroPregunta;
                    self._itemControlService.itemCode = data.idItem;
                    self.actual = self._itemControlService.item;
                    self._answerController.itemType = self.actual.type;
                    self._answerController.itemId = self.actual.itemId;
                    self._answerController.sesion = self.actual.sesion;
                    self._answerController.itemOrder = data.numeroPregunta;
                    this._addComponent.addComponent(self.actual.content, this.container, '', self);
                    //self.checkScroll();
                    self._answerController.respuesta = null;
                    self.deshabilitarContinuar = false;
                  }
                );
            } else {
              this.endTestAdaptativa();
              if (this.validarUltimaSesion()) {
                self._adaptiveService.consultarResultadoGlobal(
                  this._tokenController.token.credentialId.toString(),
                  this._answerController.sesion,
                  this._tokenController.token.tokenId,
                  this._tokenController.token.token).then(
                    (dataTotal: any) => {
                      this.construirTablaRespuestaTotal(dataTotal);
                      this.guardarPuntajePrueba(data, this._answerController.sesion);
                    }
                  );
              } else {
                this.guardarPuntajePrueba(data, this._answerController.sesion);
              }
            }
          } else {
            if (data.codigo == "10") {
              this.mensaje = "El estudiante ya ha terminado la prueba. Se cerrará la sesión."
            } else {
              this.mensaje = "Se ha presentado un error en la aplicación. Se cerrará la sesión. Por favor "
                + " contactarse con el aplicador. Código: " + data.codigo;
            }
            $('#adaptiveErrorModal').modal({ show: true });
          }
        }
      );
    });
  }

  /** Encargado de guardar el puntaje por prueba */
  public guardarPuntajePrueba(data: any, sesion: number) {
    this._adaptiveService.guardarPuntajePrueba(
      this._tokenController.token.tokenId,
      this._tokenController.token.credentialId,
      this._welcomeDataService.data.sessions[sesion - 1].subjects[0].subjectCode,
      data.puntaje,
      this._tokenController.token.token
    ).then(res => {
      $('#adaptiveEndModal').modal({ show: true });
    })
  }



  /**
   * Método que se encarga de cargar la tabla de respuestas.
   * @param data
   */
  private construirTablaRespuestaTotal(data: AdaptativePuntajeDTO) {
    let self = this;
    self.puntajeTotal = data;
    let test = data.puntaje;
    self.puntajeTotal.puntaje = [];
    for (let i = 0; i < examenPruebas.length; i++) {
      if (test[examenPruebas[i].codigo] != null) {
        let puntaje = new PuntajePruebasDTO(examenPruebas[i].nombre, test[examenPruebas[i].codigo]);
        self.puntajeTotal.puntaje.push(puntaje);
      }
    }

    for (let j = 0; j < examen.length; j++) {
      if (test[examen[j].codigo] != null
        && test[examen[j].codigo] == test[examen[j].codigo]) {
        this.puntajeTotalExamen = new PuntajePruebasDTO(examen[j].nombre, test[examen[j].codigo]);
      }
    }
  }

  /**
   * Método que se encarga de terminar la sesión de pruebas adaptivas.
   */
  public endTestAdaptativa() {
    this.allSynced = true;
    let this_self = this;
    if (this_self._configurationControlService.online) {
      this._answerService.getUnsynchronizedAnswers().then((result: Answer[]) => {
        const answers = result.filter((item) =>
          item.credencialId == this._tokenController.token.credentialId
        );
        this._answerService.postSynchronizeAll(this.token.token, answers, this.token.tokenId);
      });
      if (this.allSynced) {
        this._restService.postEndSessionToken(this._tokenController.token.token,
          this._tokenController.token.credentialId, this.actual.sesion,
          this._configurationControlService.examConfiguration.sendMail,
          this._welcomeDataService.data, this._tokenController.token.tokenId).then(
            res => {
              this.sessionInfo.ipPublica = this._configurationControlService.publicIp;
              this.sessionInfo.fechaIngreso = new Date();
              this.sessionInfo.credencial = this._configurationControlService.credencial;
            }
          );
      }
    } else {
      this.allSynced = false;
    }

  }

  /*Se encarga de la finalizacion de la sesion, borra los datos de
  indexedDB y navega hacia la pagina de informacion final*/
  public goEndSessionToken() {
    let this_self = this;
    this.loading = true;
    if (this_self._configurationControlService.online) {
      this_self._loginService.changeSessionState(this.token.token, this.token.tokenId, this.token.credentialId.toString(), Number(0), this.sessionInfo).then((res: any) => {
        let result = res == CodResp[0].codigo ? 'S' : 'N';
        if (result == 'S') {
          console.log('Se termina la sesión.')
          $('#adaptiveEndModal').modal({ show: false });
          $('#adaptiveEndModal').modal('hide');
          $('#adaptiveErrorModal').modal({ show: false });
          $('#adaptiveErrorModal').modal('hide');
          this_self._router.navigate(['/endTest']);
        }
      });
    }
    else {
      this.allSynced = false;
    }
  }


  /*Se encarga de verificar si es necesario mostrar el scroll
  cuando hay un cambio de item*/
  /*public checkScroll() {
    let video = $("video"); video.attr("controlsList", "nodownload");
    this.showScrollBtn = false;
    let self = this;
    this.position = 50;
    setTimeout(function () {
      let docHeight = $(window).height() * 0.67;
      let divHeight = $("#divScroll").height();
      if (divHeight > docHeight) {
        self.showScrollBtn = true;
      }
      else {
        self.showScrollBtn = false;
      }
    }, 500);
  }*/


  /*Realiza validaciones previas a la inserción de las respuestas */
  validateAnswer() {
    if ((this._answerController.respuesta != this._answerController.previousAnswer && this.actual.type != 'open') ||
      (this._answerController.open != this._answerController.previousAnswer && this.actual.type == 'open') ||
      (this._answerController.marcarRespuesta != this.previousMark)) {
      let this_self = this;
      if (this.actual.type == 'open') {
        let answerValue = this._answerController.getRespuesta();
        let answer = new Answer(this._tokenController.token.credentialId,
          this._answerController.itemId, this._dateServerService.getDateServer(), answerValue, 'N',
          this._answerController.sesion, this._answerController.itemOrder,
          this._answerController.publicIp, this._answerController.open,
          this._answerController.marcarRespuesta);
      } else {
        this.saveAnswer();
        this._answerService.getUnsynchronizedAnswers().then((result: Answer[]) => {
          const answers = result.filter((item) =>
            item.credencialId == this._tokenController.token.credentialId
          );
          this._answerService.postSynchronizeAll(this.token.token, answers, this.token.tokenId)
        });
      }
    }
  }


  //Validación de estados para habilitar el botón de
  public backButtonEnabled(order: number, direction: number) {
    let regla = order + direction;
    switch (regla) {
      case 1:
        this.renderBtn = false;
        break;
      default:
        if (!this._configurationControlService.examConfiguration.backButton) {
          this.renderBtn = false;
        } else {
          this.renderBtn = true;
        }
        break;
    }
  }

  /**
   * Método que se encarga de terminar la sesión y redirigir a la pantalla correspondiente.
   */
  public endAdaptive() {
    this.goEndSessionToken();
  }

  /**
   * Método que se encarga de validar que no existe ninguna respuesta vacía antes
   * de llamar la siguiente pregunta en ambiente adaptativo.
   */
  public validarRespuestaVacias(): boolean {
    var resultado = false;

    if (this._answerController.itemType == 'ing_p2' || this._answerController.itemType == 'ing_p4' || this._answerController.itemType == 'ing_p7') {
      if (this._answerController.respuesta == null
        || (this._answerController.respuesta.indexOf('|O') > 0)) {
        resultado = true
      }
    } else {
      if (this._answerController.respuesta == null) {
        resultado = true;
      }
    }

    if (resultado) {
      $('#modalResp').modal({ show: 'true' });
      this.deshabilitarContinuar = false;
    }
    return resultado;
  }

  /**
   * Método que se encarga de validar si se encuentra el usuario
   * en la última sesión.
   */
  private validarUltimaSesion() {
    this.esUltima = false;
    if (this.actual.sesion == this.welcomeData.sessions.length) {
      this.esUltima = true;
    }
    return this.esUltima;
  }

  /** Encargado de abrir el componente iframe con el pdf */
  showPdf(directory, fileName) {

    const RUTA_BASE = 'https://s3.amazonaws.com/pruelec-2017/mediaContent/';
    const url = RUTA_BASE + directory + '/' + fileName;
    this.urlPdfSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    $("#modalShowPdf").show();
    $("#modalShowPdf").draggable();
  }

  /** Encargado de cerrar el componente iframe con el pdf */
  closeShowPdf() {
    $("#modalShowPdf").hide();
  }

};
function ngAfterViewInit() {
  throw new Error('Function not implemented.');
}

